export const getObjective = ({ objective }) => objective;
export const getObjectiveName = ({ objective }) => objective?.nome ?? "";
export const getPagination = ({ pagination }) => pagination;
